import { Helmet } from 'react-helmet-async';

/**
 * Emits BreadcrumbList JSON-LD (Schema.org) for AEO/SEO. Renders its own Helmet so it can be
 * dropped anywhere in a page's JSX.
 *
 * @param {{ items: Array<{ name: string, url: string }> }} props  Ordered Home → … → current.
 */
export default function BreadcrumbJsonLd({ items }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
